<div class="production-db-content" dir="{{languageDir}}">
    <div class="content-top-box">
      <ul class="breadcrumb">
        <ul class="breadcrumb">
          <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
            <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
              (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
          </li>
        </ul>
      </ul>
      <div class="title-row-flex-both-end">
        <h1 class="main-title">{{langObj ? langObj?.AnalysisDashBoard : ('AnalysisDashBoard' | translate)}}</h1>
      </div>
    </div>
    <mat-tab-group mat-align-tabs="start">
      <mat-tab label="{{langObj ? langObj?.parametersAnalysis : ('parametersAnalysis' | translate)}}">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <form [formGroup]="AnalysisDashboardForm">
      <div class="content-top-row content-top-row-order-processing">
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <!-- <mat-label>Status</mat-label> -->
          <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)"
            placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
              (filteredReturn)="filteredGroups = $event"></mat-select-filter>
            <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
              {{group.EG_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)"
            placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
              (filteredReturn)="filteredPlants = $event"></mat-select-filter>
            <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
              {{plant.PT_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="line" (selectionChange)="onChangeLine($event)"
            placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
              (filteredReturn)="filteredLines = $event"></mat-select-filter>
            <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
              {{line.PL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select  #allSelected multiple formControlName="unit">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
          (filteredReturn)="filteredUnits = $event" ></mat-select-filter>
          <div class="select-all">
              <mat-checkbox [(ngModel)]="allSelectedParameterOption"
                              [ngModelOptions]="{standalone: true}"
                              (change)="toggleAllSelection()">Select All</mat-checkbox>
          </div>
          <mat-option  *ngFor="let unit of filteredUnits" [value]="unit.PU_Id"  (click)="onUnitChange()">
            {{unit.PU_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
       
      </div>
      <!-- Dropdown -->
      <div class="content-top-row content-top-row-order-processing">
        <!-- <div class="inputField">
          <nz-date-picker class="calender-input" id="startPicker" formControlName="dateStart" nzFormat="dd/MM/yyyy HH:mm"
            [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>
        </div>
        <div class="inputField">
          <nz-date-picker class="calender-input" id="endPicker" formControlName="dateEnd" nzFormat="dd/MM/yyyy HH:mm"
            [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>
        </div> -->
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
        >
        <mat-label> Date range
        </mat-label>
        <mat-date-range-input [formGroup]="rangeParameter" [rangePicker]="picker1">
          <input matStartDate formControlName="dateStart" placeholder="From Date" [readOnly]="true" />
          <input matEndDate formControlName="dateEnd" placeholder="To Date" [readOnly]="true" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-date-range-picker #picker1 (closed)="onParameterRangeChange()"></mat-date-range-picker>
      </mat-form-field>
        <div class="btn-position">
          <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
            (click)="onSubmit()" tooltipPosition="top">
            <img src="assets/images/search.png" alt="" width="20px" height="20px">
          </button>
        </div>
  
  
        <div class="d-flex" style="margin: 10px;">
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="today();showPhase(1);" [class.phase-active]="activeButton === 1"
              matTooltipClass="custom-tooltip" matTooltip="Current Shift">CS</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="yesterday();showPhase(2)" [class.phase-active]="activeButton === 2"
              matTooltipClass="custom-tooltip" matTooltip="Last Shift">LS</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="yesterdayFullDay();showPhase(3)" [class.phase-active]="activeButton === 3"
              matTooltipClass="custom-tooltip" matTooltip="Yesterday">1D</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="lastWeek();showPhase(4);" [class.phase-active]="activeButton === 4"
              matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="lastMonth();showPhase(5)" [class.phase-active]="activeButton === 5"
              matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
          </div>
        </div>
      </div>
    </form>
  
      <div class="chart-group">
      <div class="chart-items" style="width: 100%;">
        <div class="chart-title">{{langObj ? langObj?.parameters : ('parameters' | translate)}}  
          <div class="content-top-row content-top-row-order-processing" style="justify-content: flex-end;"> <mat-form-field  class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="float: right;">
          <mat-label>{{langObj ? langObj?.SearchParaameter : ('SearchParaameter' | translate)}}</mat-label>
          <input matInput placeholder="serach"  [(ngModel)]="searchText" (ngModelChange)="getVariableParameters()">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      </div>
      <div style="margin-top: 10px;overflow-x: auto;">
        <div style="display: flex;flex-wrap: wrap; ">
          <div *ngFor="let datapoint of datapoints1; let i1 =index" style="margin-left:10px">
            <h2 class="datapointsheading"> {{datapoint.machine == "" ? 'General' : datapoint.machine }} </h2>
            <div *ngFor="let check of datapoint.data | arrayFilterParameter: searchText; let i2 = index" style="display: inline-block;">
              <mat-checkbox style="margin: 12px 20px;" #check [checked]="check.checked"
                (change)="userSelectClick( check.Var_Id,$event)">{{ check.Var_Desc}}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="chart-group">
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.hourlyparametersAnalysis : ('parametersAnalysis' | translate)}}</div>
        <div id="onehourParametersChart"></div><br>
      </div>
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.dailyparametersAnalysis : ('parametersAnalysis' | translate)}}</div>
        <div id="onedayParametersChart"></div>
      </div>
    </div>
    </mat-tab>
    <mat-tab label="{{langObj ? langObj?.cycleAnalysis : ('cycleAnalysis' | translate)}}" >
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <form [formGroup]="CycleAnalysisForm">
      <div class="content-top-row content-top-row-order-processing">
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <!-- <mat-label>Status</mat-label> -->
          <mat-select formControlName="UserGroup1" (selectionChange)="onCycleChangeGroup($event)"
            placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
              (filteredReturn)="filteredCycleGroups = $event"></mat-select-filter>
            <mat-option *ngFor="let group of filteredCycleGroups" [value]="group.EG_Id">
              {{group.EG_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="UserPlant1" (selectionChange)="onCycleChangePlant($event)"
            placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
              (filteredReturn)="filteredCyclePlants = $event"></mat-select-filter>
            <mat-option *ngFor="let plant of filteredCyclePlants" [value]="plant.PT_Id">
              {{plant.PT_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="line" (selectionChange)="onCycleChangeLine($event)"
            placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
              (filteredReturn)="filteredCycleLines = $event"></mat-select-filter>
            <mat-option *ngFor="let line of filteredCycleLines" [value]="line.PL_Id">
              {{line.PL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}" formControlName="unit">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
          (filteredReturn)="filteredCycleUnits = $event"></mat-select-filter>
          <!-- <mat-option #allSelected (click)="toggleAllSelection()" [value]="0">Select All</mat-option> -->
          <mat-option  *ngFor="let unit of filteredCycleUnits" [value]="unit.PU_Id"  (click)="onUnitChangeCycle()">
            {{unit.PU_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="parameters"  (selectionChange)="onChangeParameterCycle()" placeholder="{{langObj ? langObj?.ParameterGroup : ('ParameterGroup' | translate)}}"
              panelClass="testClass" name="parameterGroup">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'Var_Desc'" [array]="parametersDD"
                (filteredReturn)="filteredParameters = $event"></mat-select-filter>
              <mat-option *ngFor="let parameter of filteredParameters" [value]="parameter.Var_Id">
                {{parameter.Var_Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      <!-- Dropdown -->
      <div class="content-top-row content-top-row-order-processing">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="frequency" (selectionChange)="getAnalysisDashboardCycle()"   placeholder="{{langObj ? langObj?.frequency : ('frequency' | translate)}}"
            panelClass="testClass" name="parameterGroup">
            <mat-option  value='Daily'> Daily </mat-option>
            <mat-option  value="Weekly"> Weekly </mat-option>
            <mat-option  value="Monthly"> Monthly </mat-option>
            <!-- <mat-option  value="Quartly"> Quartly </mat-option>
            <mat-option  value="Yearly"> Yearly </mat-option> -->
          </mat-select>
        </mat-form-field>
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
        >
        <mat-label> Date range
        </mat-label>
        <mat-date-range-input [formGroup]="rangeCycle" [rangePicker]="picker2">
          <input matStartDate formControlName="dateStart" placeholder="From Date" [readOnly]="true" />
          <input matEndDate formControlName="dateEnd" placeholder="To Date" [readOnly]="true" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-date-range-picker #picker2 (closed)="onCycleRangeChange();getAnalysisDashboardCycle();"></mat-date-range-picker>
      </mat-form-field>
        <!-- <div class="inputField">
          <nz-date-picker class="calender-input" id="startPicker" formControlName="dateStart" nzFormat="dd/MM/yyyy HH:mm"
            [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>
        </div>
        <div class="inputField">
          <nz-date-picker class="calender-input" id="endPicker" formControlName="dateEnd" nzFormat="dd/MM/yyyy HH:mm"
            [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>
        </div> -->
        <div class="btn-position">
          <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
            (click)="getAnalysisDashboardCycle()" tooltipPosition="top">
            <img src="assets/images/search.png" alt="" width="20px" height="20px">
          </button>
        </div>
  
       <div class="d-flex" style="margin: 10px;">
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="today_Cycle();showPhaseCycle(1);" [class.phase-active]="activeButtonCycle === 1"
              matTooltipClass="custom-tooltip" matTooltip="Current Shift">CS</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="yesterday_Cycle();showPhaseCycle(2)" [class.phase-active]="activeButtonCycle === 2"
              matTooltipClass="custom-tooltip" matTooltip="Last Shift">LS</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="yesterdayFullDay_Cycle();showPhaseCycle(3)" [class.phase-active]="activeButtonCycle === 3"
              matTooltipClass="custom-tooltip" matTooltip="Yesterday">1D</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="lastWeek_Cycle();showPhaseCycle(4);" [class.phase-active]="activeButtonCycle === 4"
              matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
          </div>
          <div class="mr-10" style="margin: inherit;">
            <p class="topBtn mx-2" (click)="lastMonth_Cycle();showPhaseCycle(5)" [class.phase-active]="activeButtonCycle === 5"
              matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
          </div>
        </div> 
        <div class="btn-position" style="margin-top: 10px;">
          <toggle-button  (changed)="checked=$event;getAnalysisDashboardCycle();">
          </toggle-button>
        </div>
      </div>
    </form>     
    <div class="chart-group">
      <div class="chart-items" style="width: 100%;" *ngIf="selectedFreq === 'Daily'">
        <div class="chart-title">{{langObj ? langObj?.cycleAnalysis : ('cycleAnalysis' | translate)}}</div>
        <div [chart]="cycleAnalysis"></div><br>
      </div>
      <div class="chart-items" style="width: 100%;" *ngIf="selectedFreq === 'Weekly'">
        <div class="chart-title">{{langObj ? langObj?.cycleAnalysis : ('cycleAnalysis' | translate)}}</div>
        <div [chart]="weekParametersChart"></div>
      </div>

      <div class="chart-items" style="width: 100%;" *ngIf="selectedFreq === 'Monthly'">
        <div class="chart-title">{{langObj ? langObj?.cycleAnalysis : ('cycleAnalysis' | translate)}}</div>
        <div [chart]="monthParametersChart"></div>
      </div>
    </div>
    </mat-tab>
    <mat-tab label="{{langObj ? langObj?.AlarmAnalysis : ('cycleAnalysis' | translate)}}">
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
      <form [formGroup]="AlarmDashboardForm">
        <div class="content-top-row content-top-row-order-processing">
          <!-- GROUP -->
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <!-- <mat-label>Status</mat-label> -->
            <mat-select formControlName="UserGroup1" (selectionChange)="onChangeAlarmGroup($event)"
              placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
                (filteredReturn)="filteredAlarmGroups = $event"></mat-select-filter>
              <mat-option *ngFor="let group of filteredAlarmGroups" [value]="group.EG_Id">
                {{group.EG_Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="UserPlant1" (selectionChange)="onChangeAlarmPlant($event)"
              placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
                (filteredReturn)="filteredAlarmPlants = $event"></mat-select-filter>
              <mat-option *ngFor="let plant of filteredAlarmPlants" [value]="plant.PT_Id">
                {{plant.PT_Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>
    
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="line" (selectionChange)="onChangeAlarmLine($event)"
              placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
                (filteredReturn)="filteredAlarmLines = $event"></mat-select-filter>
              <mat-option *ngFor="let line of filteredAlarmLines" [value]="line.PL_Id">
                {{line.PL_Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select  #allSelectedAlarm multiple formControlName="unit">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
            (filteredReturn)="filteredAlarmUnits = $event"></mat-select-filter>
            <div class="select-all">
                <mat-checkbox [(ngModel)]="allSelectedAlarmOption"
                                [ngModelOptions]="{standalone: true}"
                                (change)="toggleAllSelectionAlarm()">Select All</mat-checkbox>
            </div>
            <mat-option  *ngFor="let unit of filteredAlarmUnits" [value]="unit.PU_Id"  (click)="optionClick()">
              {{unit.PU_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </div>
        <!-- Dropdown -->
        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          >
          <mat-label> Date range
          </mat-label>
          <mat-date-range-input [formGroup]="rangeAlarm" [rangePicker]="picker">
            <input matStartDate formControlName="dateStart" placeholder="From Date" [readOnly]="true" />
            <input matEndDate formControlName="dateEnd" placeholder="To Date" [readOnly]="true" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker (closed)="onAlarmRangeChange()"></mat-date-range-picker>
        </mat-form-field>
        
          <div class="d-flex" style="margin: 10px;">
            <div class="mr-10" style="margin: inherit;">
              <p class="topBtn mx-2" (click)="today_Alarm();showPhase(1);" [class.phase-active]="activeButton === 1"
                matTooltipClass="custom-tooltip" matTooltip="Current Shift">CS</p>
            </div>
            <div class="mr-10" style="margin: inherit;">
              <p class="topBtn mx-2" (click)="yesterday_Alarm();showPhase(2)" [class.phase-active]="activeButton === 2"
                matTooltipClass="custom-tooltip" matTooltip="Last Shift">LS</p>
            </div>
            <div class="mr-10" style="margin: inherit;">
              <p class="topBtn mx-2" (click)="yesterdayFullDay_Alarm();showPhase(3)" [class.phase-active]="activeButton === 3"
                matTooltipClass="custom-tooltip" matTooltip="Yesterday">1D</p>
            </div>
            <div class="mr-10" style="margin: inherit;">
              <p class="topBtn mx-2" (click)="lastWeek_Alarm();showPhase(4);" [class.phase-active]="activeButton === 4"
                matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
            </div>
            <div class="mr-10" style="margin: inherit;">
              <p class="topBtn mx-2" (click)="lastMonth_Alarm();showPhase(5)" [class.phase-active]="activeButton === 5"
                matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
            </div>
          </div>
        </div>
      </form>
      <div class="chart-group">
        <div class="chart-items" style="width: 100%;">
        <div class="chart-title">{{langObj ? langObj?.parameters : ('parameters' | translate)}}
          <div class="content-top-row content-top-row-order-processing" style="justify-content: flex-end;"> <mat-form-field  class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="float: right;">
            <mat-label>{{langObj ? langObj?.SearchParaameter : ('SearchParaameter' | translate)}}</mat-label>
            <input matInput placeholder="serach" [(ngModel)]="searchTextAlaram" (ngModelChange)="getAlarmVariableParameters()">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        </div>
        <div style="margin-top: 10px;overflow-x: auto;">
          <div style="display: flex;flex-wrap: wrap; ">
            <div *ngFor="let datapoint of parametersList; let i1 =index" style="margin-left:10px">
              <h2 class="datapointsheading"> {{datapoint.machine == "" ? 'General' : datapoint.machine }} </h2>
              <div *ngFor="let check of datapoint.data | arrayFilterParameter: searchTextAlaram; let i2 = index">
                <mat-checkbox style="margin: 12px 20px;" #check [checked]="check.checked"
                  (change)="parameterSelect( check.Var_Id,$event)">{{ check.Var_Desc}}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="chart-group">
        <div class="chart-items" style="width: 100%;">
          <div class="chart-title">{{langObj ? langObj?.AlarmAnalysis : ('AlarmAnalysis' | translate)}}</div>
          <div [chart]="alarmAnalysis"></div><br>
        </div>
        <!-- <div class="chart-items">
          <div class="chart-title">{{langObj ? langObj?.dailyparametersAnalysis : ('parametersAnalysis' | translate)}}</div>
          <div id="onedayParametersChart"></div>
        </div> -->
      </div>
    </mat-tab>
    </mat-tab-group>
  </div>